import { GlobalState } from '../../reducers';
import { BiometricAuthenticationState } from './reducers';

const biometricAuthenticationPopoverSelector = (
  store: GlobalState,
): BiometricAuthenticationState => (
  store.apps.manual.biometricAuthentication
);

export default {
  biometricAuthenticationPopoverSelector,
};
